export default {"src":"/_next/static/media/testpsychologie.c18e5c34.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};